// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Mv2M6","gfeWrapper":"CalendarEvent_gfeWrapper__D9ePC"};